import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractDataProvider } from '../AbstractDataProvider';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable, of } from 'rxjs';
import { GridComponent } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { GenericFilterModel, QueryStringParam } from '../security/QueryStringParam';
import { finalize } from 'rxjs/operators';
import { ResponseModel } from '../../shared/model/interfaces';
import { DictionaryPipe } from '../../shared/pipes/dictionary.pipe';
import { getErrorMessageText } from '../helper';
import { HttpHeaders } from '@angular/common/http';

type Fund = any;
type Year = any;
type FundAndYears = any;


@Component({
    selector: 'app-tax',
    templateUrl: './tax.component.html',
    styleUrls: ['./tax.component.scss'],
    providers: [DictionaryPipe],
    standalone: false
})
export class TaxComponent implements OnInit {

  @ViewChild(GridComponent) kendoGridComponent: GridComponent;
  public downloadDocumentImagUrl: string = this.abstractDataProvider.baseUrl + 'api/File/FileDownloadFromDocumentImage?SeqNum=';
  public sort: SortDescriptor[] = [{
    field: 'Year',
    dir: 'desc'
  }];
  public display = false;
  public alertMessage: string;
  public funds: Fund[] = [];
  public years: Year[] = [];
  public totalRecords: number;
  public loading: boolean;
  public rowPerPage = 50;
  public currentPageNo = 1;
  public data: Observable<any>;
  public taxForms = [];
  public fund = '0';
  public year = 0;
  public introText: string;
  public skipRecords = 0;
  rowSelectionList = [];
  canSelect: boolean;

  private allDataLoaded = false;

  get isAllSelected() {
    return this.taxForms.length === this.rowSelectionList.length;
  }

  constructor(
    private abstractDataProvider: AbstractDataProvider,
    private authService: AuthServiceCustom,
    private ngxService: NgxUiLoaderService,
    private dictionaryPipe: DictionaryPipe) {
  }

  ngOnInit() {
    this.canSelect = this.authService.UserType === 'R';


    this.abstractDataProvider.getData('api/Tax/GetFundAndYears')
      .pipe(
    ).subscribe((funds: FundAndYears) => {
      this.funds = funds.Funds;
      this.years = funds.Years;
      this.year = this.years[0].Year;
      this.search();
    },
      error => {
        this.display = true;
        this.alertMessage = getErrorMessageText(error);
      });
    this.getIntroText();
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.search();
  }

  public loadMore(countToLoad = null, afterLoad: () => void = null): void {
    if (this.loading)
      return;

    if (!this.allDataLoaded) {
      this.skipRecords = this.taxForms.length;
      this.loading = true;
      this.makeAPICallGetData(countToLoad || this.rowPerPage, afterLoad);
    } else {
      afterLoad();
    }
  }

  public prevent(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  public downloadDocument(docSeqNum: any, fileNum: any): void {
    this.abstractDataProvider.getData(`api/File/IsFileExist?SeqNum=${docSeqNum}&forWhat=tax`)
      .pipe(
        finalize(() => this.ngxService.stop())
      )
      .subscribe(
        posts => {
          if (posts.Message) {
            this.display = true;
            this.alertMessage = posts.Message;
          } else if (posts.DocSeqNum) {
            // window.open(`${this.downloadDocumentImagUrl + posts.DocSeqNum}&forWhat=tax&CurrentUserNumber=${posts.CurrentUserNumber}&FileNum=${fileNum}`, '_blank');
            const url = `${this.downloadDocumentImagUrl + posts.DocSeqNum}&forWhat=tax&CurrentUserNumber=${posts.CurrentUserNumber}&FileNum=${fileNum}`
            this.abstractDataProvider.downloadFile(url)
            .subscribe(_ => {}, error =>{
              this.display = true;
              this.alertMessage = getErrorMessageText(error);
            })
          } else {
            // Not Found
            this.display = true;
            this.alertMessage = this.dictionaryPipe.transform('FILE_NOT_FOUND');
          }
        },
        error => {
          this.display = true;
          this.alertMessage = getErrorMessageText(error);
        }
      );
  }

  public downloadDocumentDynamic(dataItem): void {
    const queryParam: QueryStringParam[] = [
      { Key: 'cboFundId', Value: dataItem.FundId },
      { Key: 'cboTaxYear', Value: dataItem.Year + '' },
      { Key: 'txtFax', Value: '' },
      { Key: 'chkMaskTaxId', Value: 'true' },
      { Key: 'chkFaxFlag', Value: 'false' },

      { Key: 'InvestorNum', Value: dataItem.InvestorNum },
      { Key: 'InvestmentNum', Value: dataItem.InvestmentNum },
      { Key: 'cboTaxType', Value: dataItem.FileType }
    ];
    const is1099 = ['1099DIV', '1099B', '1099INT', '1099OID'].includes(dataItem.FileType);
    const apiUrl = is1099
      ? 'api/Tax/GenerateDynamicTax1099'
      : 'api/Tax/GenerateDynamicTaxK1';

    this.abstractDataProvider.postData(queryParam, apiUrl).subscribe(
      posts => {
        if (posts.Data.url) {
          // window.open(this.abstractDataProvider.baseUrl + posts.Data.url, '_blank');
          this.abstractDataProvider.downloadFile(this.abstractDataProvider.baseUrl + posts.Data.url)
            .subscribe(_ => {}, error =>{
              this.display = true;
              this.alertMessage = getErrorMessageText(error);
            });
        } else if (posts.Data.AlertMsgs.length > 0) {
          // TODO: implement
        }
      },
      error => {
        // TODO: implement
      }
    );
  }

  public downloadDocumentForTax(TaxGuide: any): void {
    this.abstractDataProvider.getData(`api/File/IsFileExist?SeqNum=${TaxGuide}&forWhat=form`)
      .pipe(
        finalize(() => this.ngxService.stop())
      )
      .subscribe(
        posts => {
          if (posts.Message) {
            this.display = true;
            this.alertMessage = posts.Message;
          } else if (posts.DocSeqNum) {
            // window.open(`${this.downloadDocumentImagUrl}${posts.DocSeqNum}&forWhat=taxguide&CurrentUserNumber=${posts.CurrentUserNumber}&FileNum=0`, '_blank');
            const url = `${this.downloadDocumentImagUrl}${posts.DocSeqNum}&forWhat=taxguide&CurrentUserNumber=${posts.CurrentUserNumber}&FileNum=0`;
            this.abstractDataProvider.downloadFile(url)
            .subscribe(_ => {}, error =>{
              this.display = true;
              this.alertMessage = getErrorMessageText(error);
            });
          } else {
            // Not Found
            this.display = true;
            this.alertMessage = this.dictionaryPipe.transform('FILE_NOT_FOUND');
          }
        },
        error => {
          this.display = true;
          this.alertMessage = getErrorMessageText(error);
        }
      );
  }

  onConfirm(): void {
    this.display = false;
  }

  public search(): void {
    this.currentPageNo = 1;
    this.allDataLoaded = false;
    this.taxForms = [];
    this.loading = true;
    this.skipRecords = 0;
    this.makeAPICallGetData(this.rowPerPage);
  }

  private makeAPICallGetData(countToLoad: number = null, afterLoad: () => void = null): void {
    const genericFilterModel: GenericFilterModel = {
      Filters: [
        { Key: 'year', Value: this.year.toString() },
        { Key: 'fund', Value: this.fund }
      ],
      PageNo: this.currentPageNo,
      PageSize: countToLoad,
      SortField: this.sort[0].field,
      SortOrder: this.sort[0].dir,
      SkipRecords: this.skipRecords
    };

    this.rowSelectionList = [];

    this.abstractDataProvider.postData(genericFilterModel, 'api/Tax/GetTaxForms')
      .pipe(
        finalize(() => {
          this.loading = false;
          this.ngxService.stop();
        }),

      ).subscribe((statement: ResponseModel<any>) => {
        if (genericFilterModel.SkipRecords === 0) {
          this.totalRecords = statement.TotalCount;
        }
        if (statement.Data.length > 0) {
          this.taxForms = [...this.taxForms, ...statement.Data];
          this.taxForms.forEach((tf, i) => tf.index = i);
          if (this.totalRecords === this.taxForms.length) {
            this.allDataLoaded = true;
          }
        } else {
          this.allDataLoaded = true;
        }
        if (afterLoad) {
          afterLoad();
        }
      },
        error => {
          this.display = true;
          this.alertMessage = getErrorMessageText(error);
        });
  }

  private getIntroText(): void {
    this.introText = this.authService.getIntroText('TAX');
  }

  downloadSelected() {
    if (!this.rowSelectionList || this.rowSelectionList.length < 0) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('SELECT_ANY_STATEMENTS_FOR_DOWNLOAD');
      return;
    }

    if (this.isAllSelected) {
      this.loadMore(this.totalRecords - this.rowSelectionList.length, () => {
        this.bulkDownload(this.taxForms);
      });
    } else {
      const itemsToSend = this.rowSelectionList.map(index => this.taxForms.find(tf => tf.index === index));
      this.bulkDownload(itemsToSend);
    }
  }

  bulkDownload(itemsToSend) {
    this.abstractDataProvider.postData(itemsToSend, 'api/Tax/PrintTaxesDownload', {
      responseType: 'blob',
      observe: 'response'
    })
      .subscribe(
        posts => {
          const responseHeaders = (posts.headers as HttpHeaders);
          const contentDisposition = responseHeaders.get('content-disposition');
          const filename = contentDisposition?.split(';')[1]?.split('filename')[1]?.split('=')[1]?.trim();
          this.downLoadFile(posts.body, filename ?? 'Taxes.zip', 'application/zip');
          this.ngxService.stop();
          this.rowSelectionList = [];
        },
        error => {
          this.ngxService.stop();
          this.display = true;
          this.alertMessage = getErrorMessageText(error);
        }
      );
  }

  downLoadFile(blob: Blob, fileName: string, type: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.setAttribute("download", fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
